/* Cart upsell block: snippets/cart-upsell.liquid, rendered by sections/main-cart.liquid.
   Rolled out from the Intelligems test "Cart — Solar Shield Upsell", Variant B (rev 3).

   The server renders the block and decides eligibility (non-empty cart, product not in
   the cart, product available) and the initial selection. cart.js replaces the whole
   <main-cart> markup after every quantity change or removal, so this element is torn
   down and re-created with fresh server state each time. This script only handles the
   shopper's own interactions: choosing option values and adding one unit. */
(function () {
  'use strict';

  if (customElements.get('cart-upsell')) return;

  var COOLDOWN_MS = 350;

  /* Page-lifetime state keyed by product id. It outlives the element, because
     cart.js re-creates it on every cart update:
     - a selection the shopper made by hand wins over the server's preselect
       (Variant B's `touched` state);
     - an Add still in flight keeps the new element busy, so no second Add
       can be sent while the first one is pending. */
  var memory = {};
  var inflight = {};
  var lastCartUpdate = 0;

  document.addEventListener('cart:updated', function () {
    lastCartUpdate = Date.now();
    hideLegacy();
  });

  /* ---------------------------------------------------------------------------
     Intelligems legacy guard.
     Variant B ran as injected Intelligems code (namespace thg-cart-ss,
     #thg-cart-ss-upsell, window.__THG_CART_SS__). That code bails out on start when
     window.__THG_CART_SS__ already exists, so claiming the flag here stops it from
     booting when it runs after this file. If it ran first, its node is hidden by
     cart-upsell.css and removed here. Either way only this block can add to cart.
     The experience still has to be switched off in Intelligems before launch.
     ------------------------------------------------------------------------- */
  function hideLegacy() {
    var nodes = document.querySelectorAll('#thg-cart-ss-upsell');
    for (var i = 0; i < nodes.length; i++) nodes[i].remove();
  }

  if (!window.__THG_CART_SS__) {
    window.__THG_CART_SS__ = { owner: 'theme', render: hideLegacy, state: {} };
  } else if (window.__THG_CART_SS__.owner !== 'theme') {
    console.warn('[cart-upsell] Intelligems "Cart — Solar Shield Upsell" code is still active on this page. ' +
      'Its block is suppressed in favour of the theme block. Turn the experience off in Intelligems.');
  }

  function routes() { return (window.theme && window.theme.routes) || {}; }

  function rootPath(p) {
    var r = routes().root_url || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r + String(p).replace(/^\//, '');
  }

  function cartUrl() { return routes().cart_url || rootPath('cart'); }

  function fetchConfig(type, method) {
    if (window.theme && theme.utils && theme.utils.fetchConfig) return theme.utils.fetchConfig(type, method);
    return {
      method: method || 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/' + (type || 'json') }
    };
  }

  function focusNoScroll(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  class CartUpsell extends HTMLElement {
    connectedCallback() {
      if (this.data) return;

      var json = this.querySelector('[data-upsell-data]');
      try { this.data = JSON.parse(json.textContent); } catch (e) { return; }

      var saved = memory[this.data.productId];
      if (saved && this.isValidPrefix(saved.values)) {
        this.values = saved.values.slice();
        this.expanded = saved.expanded;
      } else {
        this.values = this.data.initial.values.slice();
        this.expanded = this.data.initial.expanded;
      }
      this.error = '';

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      hideLegacy();
      this.update();
    }

    get busy() { return !!inflight[this.data.productId]; }

    set busy(value) { inflight[this.data.productId] = !!value; }

    /* ---------------- variant logic ---------------- */

    /* True when every chosen value still leads to at least one variant. */
    isValidPrefix(values) {
      if (!values || values.length > this.data.optionCount) return false;
      return this.data.variants.some(function (v) {
        for (var i = 0; i < values.length; i++) if (v.options[i] !== values[i]) return false;
        return true;
      });
    }

    selectedVariant() {
      var d = this.data;
      if (d.single) return d.variants[0] || null;
      if (this.values.length !== d.optionCount) return null;
      var values = this.values;
      for (var i = 0; i < d.variants.length; i++) {
        var v = d.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { match = false; break; }
        if (match) return v;
      }
      return null;
    }

    /* Reachability of one option value given the values chosen on earlier levels. */
    valueState(index, value) {
      var out = { reachable: false, available: false };
      var values = this.values;
      this.data.variants.forEach(function (v) {
        for (var j = 0; j < index; j++) if (v.options[j] !== values[j]) return;
        if (v.options[index] !== value) return;
        out.reachable = true;
        if (v.available) out.available = true;
      });
      return out;
    }

    /* Distinct values of one option reachable from the values chosen above it, in
       variant order. Used to rebuild a dropdown so it only offers compatible values. */
    reachableValues(index) {
      var out = [];
      var values = this.values;
      this.data.variants.forEach(function (v) {
        for (var j = 0; j < index; j++) if (v.options[j] !== values[j]) return;
        if (out.indexOf(v.options[index]) === -1) out.push(v.options[index]);
      });
      return out;
    }

    remember() {
      memory[this.data.productId] = { values: this.values.slice(), expanded: this.expanded };
    }

    /* Dropdown mode: rebuild each <select> from the current selection. Options are only
       replaced when the list actually changes, so an open native picker is not reset. */
    updateSelects() {
      var self = this;
      var d = this.data;
      var last = d.optionCount - 1;

      this.querySelectorAll('select[data-option-index]').forEach(function (select) {
        var index = parseInt(select.getAttribute('data-option-index'), 10);
        var complete = self.values.length >= index;
        var list = [{ value: '', text: complete ? d.strings.choose : d.strings.blank, disabled: false }];

        if (complete) {
          self.reachableValues(index).forEach(function (value) {
            var soldOut = index === last && !self.valueState(index, value).available;
            list.push({ value: value, text: value + (soldOut ? d.strings.soldOut : ''), disabled: soldOut });
          });
        }

        var signature = JSON.stringify(list);
        if (select._signature !== signature) {
          select.textContent = '';
          list.forEach(function (item) {
            var option = document.createElement('option');
            option.value = item.value;
            option.textContent = item.text;
            option.disabled = item.disabled;
            select.appendChild(option);
          });
          select._signature = signature;
        }

        select.disabled = !complete;
        select.value = self.values[index] || '';
      });
    }

    /* ---------------- render ---------------- */

    update() {
      var d = this.data;
      var sv = this.selectedVariant();
      var showSelector = !d.single && (this.expanded || !sv);
      var self = this;

      var href = sv && !d.single ? sv.url : d.url;
      this.querySelectorAll('[data-upsell-link]').forEach(function (a) { a.setAttribute('href', href); });

      var img = this.querySelector('[data-upsell-img]');
      var src = (sv && sv.image) || d.image;
      if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);

      var price = sv ? sv.price : d.base.price;
      var compare = sv ? sv.compare : d.base.compare;
      var save = sv ? sv.save : d.base.save;
      this.querySelector('[data-upsell-price]').textContent = price;
      var compareEl = this.querySelector('[data-upsell-compare]');
      compareEl.textContent = compare || '';
      compareEl.hidden = !compare;
      var saveEl = this.querySelector('[data-upsell-save]');
      saveEl.textContent = save ? 'SAVE ' + save : '';
      saveEl.hidden = !save;

      var fitment = this.querySelector('[data-upsell-fitment]');
      if (fitment) {
        fitment.hidden = showSelector || !sv;
        this.querySelector('[data-upsell-fitment-text]').textContent = sv ? sv.options.join(' · ') : '';
      }

      var selector = this.querySelector('[data-upsell-selector]');
      if (selector) {
        selector.hidden = !showSelector;
        var last = d.optionCount - 1;

        this.querySelectorAll('[data-upsell-selector] [role="group"]').forEach(function (group, index) {
          var complete = self.values.length >= index;
          var placeholder = group.querySelector('[data-upsell-placeholder]');
          if (placeholder) placeholder.hidden = complete;

          group.querySelectorAll('.cart-upsell__pill').forEach(function (pill) {
            var value = pill.getAttribute('data-value');
            var state = complete ? self.valueState(index, value) : { reachable: false, available: false };
            var selected = self.values[index] === value;
            var soldOut = index === last && !state.available;

            pill.hidden = !(complete && state.reachable);
            pill.disabled = soldOut;
            pill.classList.toggle('is-selected', selected);
            pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
            var tag = pill.querySelector('.cart-upsell__soldout');
            if (tag) tag.hidden = !soldOut;
          });
        });

        this.updateSelects();

        var hint = this.querySelector('[data-upsell-hint]');
        if (hint) hint.hidden = !!sv;
      }

      var btn = this.querySelector('[data-upsell-add]');
      btn.disabled = this.busy || !sv || !sv.available;
      btn.textContent = this.busy ? d.strings.adding : d.strings.add;

      var err = this.querySelector('[data-upsell-error]');
      err.textContent = this.error || '';
      err.hidden = !this.error;
    }

    /* ---------------- interaction ---------------- */

    onClick(event) {
      var target = event.target.closest('button');
      if (!target || !this.contains(target) || target.disabled) return;

      if (target.hasAttribute('data-upsell-add')) {
        this.add();
        return;
      }

      if (target.hasAttribute('data-upsell-change')) {
        this.expanded = true;
        this.remember();
        this.update();
        /* Change disappears: land on the selected pill (or the first dropdown). */
        focusNoScroll(this.querySelector('.cart-upsell__pill.is-selected:not([hidden])') ||
          this.querySelector('.cart-upsell__pill:not([hidden]):not(:disabled)') ||
          this.querySelector('select[data-option-index]:not(:disabled)'));
        return;
      }

      if (target.classList.contains('cart-upsell__pill')) {
        var index = parseInt(target.getAttribute('data-option-index'), 10);
        /* Choosing a value clears every later level. Choosing on the first level
           keeps the selector open, as Variant B does for a model click. */
        this.values = this.values.slice(0, index);
        this.values[index] = target.getAttribute('data-value');
        if (index === 0) this.expanded = true;
        this.error = '';
        this.remember();
        this.update();
        /* A completed selection can collapse the selector; keep focus in the block. */
        if (target.hidden || target.offsetParent === null) {
          focusNoScroll(this.querySelector('[data-upsell-change]'));
        }
      }
    }

    /* Dropdown mode. Same rules as a pill click: a new value clears every later level,
       the first level keeps the selector open, and clearing a level ("Select…") clears
       it and everything below. */
    onChange(event) {
      var select = event.target;
      if (!select || select.tagName !== 'SELECT' || !select.hasAttribute('data-option-index')) return;

      var index = parseInt(select.getAttribute('data-option-index'), 10);
      this.values = this.values.slice(0, index);
      if (select.value) this.values[index] = select.value;
      if (index === 0) this.expanded = true;
      this.error = '';
      this.remember();
      this.update();
      /* A completed selection can collapse the selector; keep focus in the block. */
      if (select.offsetParent === null) focusNoScroll(this.querySelector('[data-upsell-change]'));
    }

    themeBusy() {
      var root = this.closest('main-cart, cart-drawer');
      return !!(root && root.querySelector('.loader:not([hidden])'));
    }

    /* The element may have been re-created by a cart update while the request was
       pending; report on whichever instance is on the page now. */
    fail(message) {
      this.busy = false;
      var el = this.isConnected ? this : document.getElementById(this.id);
      if (!el || !el.data) return;
      el.error = message;
      el.update();
      focusNoScroll(el.querySelector('[data-upsell-add]'));
    }

    /* On /cart: navigate, the server renders the updated cart. In the cart drawer
       (cart drawer A/B treatment) the drawer is refreshed in place through the theme's
       own cart update, the same path the product form uses; /cart stays the fallback. */
    goToCart(drawer) {
      if (!drawer || !window.theme || !window.theme.pubsub) {
        window.location.assign(cartUrl());
        return;
      }
      var self = this;
      var sectionId = drawer.getAttribute('data-section-id');
      Promise.all([
        fetch(cartUrl() + '.js', fetchConfig('json', 'GET')).then(function (response) { return response.json(); }),
        /* No Accept header: with a JSON Accept Shopify leaves the express checkout buttons out
           of a GET ?sections= answer (the answer is JSON either way). */
        fetch(rootPath('?sections=' + encodeURIComponent(sectionId)), { credentials: 'same-origin' }).then(function (response) { return response.json(); })
      ])
        .then(function (results) {
          var cart = results[0];
          cart.sections = results[1];
          self.busy = false;
          window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cart: cart });
        })
        .catch(function () {
          /* Marks the fallback for the A/B diagnostics on /cart (th_cart_page_view). */
          if (window.thCartDrawer && typeof window.thCartDrawer.mark === 'function') window.thCartDrawer.mark('upsell');
          window.location.assign(cartUrl());
        });
    }

    add() {
      if (this.busy) return;                       /* synchronous double-click guard */
      var sv = this.selectedVariant();
      if (!sv || !sv.available) return;

      if (this.themeBusy() || Date.now() < lastCartUpdate + COOLDOWN_MS) {
        this.error = this.data.strings.busy;
        this.update();
        focusNoScroll(this.querySelector('[data-upsell-add]'));
        return;
      }

      var id = sv.id;                              /* captured now: later clicks cannot alter the payload */
      var self = this;
      var drawer = this.closest('cart-drawer');
      this.busy = true;
      this.error = '';
      this.update();

      var config = fetchConfig('javascript');
      config.body = JSON.stringify({ items: [{ id: id, quantity: 1 }] });

      fetch(routes().cart_add_url || rootPath('cart/add'), config)
        .then(function (response) { return response.json(); })
        .then(function (added) {
          if (added && added.status) {             /* 422: inventory or cart rule */
            self.fail(added.description || added.message || self.data.strings.rejected);
            self.refreshAvailability();
            return;
          }
          /* Success: let the server render the updated cart. busy stays set so the
             button cannot be pressed again while the navigation is in progress. */
          self.goToCart(drawer);
        })
        .catch(function () { self.recover(drawer); });
    }

    /* Ambiguous network outcome. Read-only check, creates no cart mutation. If the
       item made it into the cart, navigate instead of offering a retry that could
       add it twice. */
    recover(drawer) {
      var self = this;
      fetch(cartUrl() + '.js', fetchConfig('json', 'GET'))
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var has = (cart.items || []).some(function (item) { return item.product_id === self.data.productId; });
          if (has) { self.goToCart(drawer); return; }
          self.fail(self.data.strings.failed);
        })
        .catch(function () { self.goToCart(drawer); });
    }

    /* After a 422, refresh availability without re-rendering the block. */
    refreshAvailability() {
      var self = this;
      fetch(rootPath('products/' + this.data.handle + '.js'), { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (!product || !product.variants) return;
          var byId = {};
          product.variants.forEach(function (v) { byId[v.id] = v.available; });
          var el = self.isConnected ? self : document.getElementById(self.id);
          if (!el || !el.data) return;
          el.data.variants.forEach(function (v) { if (v.id in byId) v.available = !!byId[v.id]; });
          el.update();
        })
        .catch(function () {});
    }
  }

  customElements.define('cart-upsell', CartUpsell);
})();